/** Shared display formatters for the Pyramida UI (locale-aware via i18n). */
import { activeLocale } from '../i18n';

/** Compact TON amount, e.g. 1234.5 -> "1,234.5" (separators follow the locale). */
export function formatTon(value: number, maxFractionDigits = 2): string {
  return value.toLocaleString(activeLocale(), {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxFractionDigits,
  });
}

/** Large integer counts, e.g. 12345 -> "12,345" (separators follow the locale). */
export function formatInt(value: number): string {
  return Math.round(value).toLocaleString(activeLocale());
}

/** PRMD amounts, abbreviated for large values via locale-aware compact notation. */
export function formatPrmd(value: number): string {
  if (value >= 1_000) {
    return new Intl.NumberFormat(activeLocale(), {
      notation: 'compact',
      maximumFractionDigits: 2,
    }).format(value);
  }
  return formatTon(value, 2);
}

/** Shortened address: EQAb…x9Yz. */
export function shortenAddress(addr: string | null, head = 4, tail = 4): string {
  if (!addr) return '—';
  if (addr.length <= head + tail + 1) return addr;
  return `${addr.slice(0, head)}…${addr.slice(-tail)}`;
}

/** Unix-seconds timestamp -> localized date/time, or "—" when unset (0). */
export function formatDateTime(unixSeconds: number): string {
  if (!unixSeconds) return '—';
  return new Date(unixSeconds * 1000).toLocaleString(activeLocale(), {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
